import session from './session';
import config from '../config';
export const isAdmin = props => {
	const { history, match } = props;

	let allowedUrls = [
		'/login',
		'/inbox',
		'/message-audit',
		'/contacts',
		'/templates',
		'/contacts/:contactId',
		'/contacts/:contactId/:convoId',
		'/settings',
		// '/settings/:type',
		// '/settings/profile',
		'/settings/availability',
		'/campaign',
		'/qrcode',
		'/hiring-sign',
		'/campaign/create',
		'/campaign/:campaignId',
		'/interview-invites',
		'/interview-invites/calendar',
		'/interview-invites/integrations',
		'/interview-invites/integrations/:type',
		'/groups',
		'/group/create',
		'/groups/:groupId',
		'/account-setup',
		'/account-setup/send-first-sms',
		'/account-setup/integrate-calendar',
		'/account-setup/integrate-calendar/:type',
		// '/integrations',
		// '/integrations/:type',

		'/module-group',
		'/module-group/view/:modulegroupId',
		'/module-group/view2/:modulegroupId',
		'/getting-started',
		'/dashboard',
		'/apply-by-text',
		'/ai-assistants',
		'/client-users',
		'/companies'
	];

	const userRole = session.get('userData').role || '';
	const isAdmin = userRole === config.userRoles.ghAdmin;
	
	if (!isAdmin && allowedUrls.indexOf(match.path) < 0) {
		history.replace({ pathname: '/login' });
		return false;
	}

	return true;
};
